(function () {
  angular.module('MktzapApp.Controllers')
    .controller('FacebookController', facebook);
  facebook.$inject = ['$scope', '$rootScope', '$http', '$stateParams', '$location', 'CompanyService', 'FoundationApi', 'FacebookService', '$state', 'NotificationService'];
  function facebook ($scope, $rootScope, $http, $stateParams, $location, CompanyService, FoundationApi, FacebookService, $state, NotificationService) {
    var fbAsyncInit = function () {
      FB.init({
        appId: appId,
        xfbml: true,
        version: 'v2.7'
      });
    };
    fbAsyncInit()
    var vm = this;
    vm.is_loading = false;

    CompanyService.findForChannel({
      type: 'facebook'
    })
      .$promise
      .then(function (data) {
        vm.company = data;
      })
      .then(fetchPagesFromMktzapPromise)
      .then(function (data) {
        vm.pages = data;
      })
      .catch(function (error) {
        var message = 'Erro trazer a listagem de dados';
        NotificationService.errorHandler(error, message);
      });

    // FACEBOOK
    vm.facebookLogin = function () {
      vm.is_loading = true;
      loginPromise()
        .then(function (data) {
          vm.facebook_user = data;
          return vm.facebook_user.token;
        })
        .then(fetchPagesFromFacebookPromise)
        .then(function (data) {
          vm.is_loading = false;
          vm.user_pages = data;
        })
        .catch(function (error) {
          vm.is_loading = false;
          NotificationService.errorHandler(error, $scope.labels.errorAttachedPages);
          FoundationApi.publish('facebookPageModal', 'close');
        });
    };
    vm.configurePageModal = function (pageIndex) {
      vm.currentPage = vm.user_pages[pageIndex];
      FoundationApi.publish('facebookPageModal', 'open');
    };
    vm.editPage = function (page) {
      vm.currentPage = page;
      FoundationApi.publish('facebookPageModal', 'open');
    };
    vm.subscribe = function (page) {
      var token = page.access_token;
      var page_id = page.page_id;
      var shouldCallFacebookUpdate = false;

      if (!page_id) {
        page_id = page.id;
      }

      for (var i in vm.user_pages) {
        if (vm.user_pages[i]['id'] == page_id) {
          token = vm.user_pages[i]['access_token'];
          shouldCallFacebookUpdate = true;
        }
      }

      if (vm.facebook_user && shouldCallFacebookUpdate) {
        var promise = unsubscribePromise(page, token, page_id)
          .then(function (page) {
            return subscribePagePromise(page, token, page_id);
          })
          .then(function (page) {
            return createPagePromise(page, token, page_id);
          });
      } else {
        var promise = vm.update(page);
      }

      promise
        .then(function (data) {
          NotificationService.successHandler(data, $scope.labels.intConfigSuccess);
        })
        .then(fetchPagesFromMktzapPromise)
        .then(function (data) {
          vm.pages = data;
          FoundationApi.publish('facebookPageModal', 'close');
        })
        .catch(function (error) {
          var message = $scope.labels.errorParam;
          NotificationService.errorHandler(error, message);
        });
    }
    vm.update = function (page) {
      return FacebookService.update({
        id: page.id
      }, page).$promise;
    }
    vm.unsubscribe = function (index) {
      var page = vm.pages[index];
      removePagePromise(page, page.access_token, page.page_id)
        .then(function (data) {
          NotificationService.successHandler(data, $scope.labels.deletedIntSuc);
          return fetchPagesFromMktzapPromise();
        })
        .then(function (data) {
          vm.pages = data;
        })
        .catch(function (response) {
          NotificationService.errorHandler(response, $scope.labels.errorParam);
        });
    };

    vm.goToTriggers = function (channel) {
      $state.go('main.triggers', { type: 'facebook', id: channel.id });
    }

    function fetchPagesFromMktzapPromise () {
      return FacebookService
        .pages({
          id: $rootScope.user_data.company_id
        })
        .$promise;
    };
    function createPagePromise (page, token, page_id) {
      return FacebookService
        .subscribe({},
          {
            sector_id: page.sector_id,
            page_id: page_id,
            name: page.name,
            processor: page.processor,
            access_token: token,
            company_id: $rootScope.user_data.company_id
          })
        .$promise;
    }
    function removePagePromise (page, token, page_id) {
      if (vm.facebook_user) {
        return unsubscribePromise(page, token, page_id).then(deletePagePromise);
      } else {
        return deletePagePromise(page);
      }
    }
    function subscribePagePromise (selectedPage, token, page_id) {
      var page = selectedPage;
      return new Promise(function (resolve, reject) {
        FB.api(page_id + '/subscribed_apps', 'POST', {
          subscribed_fields: ['messages'],
          access_token: token
        }, function (response) {
          if (response.error) {
            reject(response.error);
          }
          resolve(page);
        });
      });
    }
    function deletePagePromise (page) {
      return FacebookService
        .remove({ id: page.id },
          {
            sector_id: page.sector_id,
            page_id: page.id,
            name: page.name,
            access_token: page.access_token,
            company_id: $rootScope.user_data.company_id
          }).$promise;
    }
    function unsubscribePromise (selectedPage, token, page_id) {
      var page = selectedPage;
      return new Promise(function (resolve, reject) {
        FB.api(page_id + '/subscribed_apps', 'DELETE', {
          access_token: token
        }, function (response) {
          resolve(page);
        });
      });
    }
    function loginPromise () {
      return new Promise(function (resolve, reject) {
        FB.login(function (response) {
          if (response.error) {
            reject(response.error);
          }
          var fb_user = {
            token: response.authResponse.accessToken,
            status: response.status
          };
          resolve(fb_user);
        }, { scope: ['public_profile', 'manage_pages', 'pages_messaging'] });
      });
    }
    function fetchPagesFromFacebookPromise (tk) {
      var token = tk;
      return new Promise(function (resolve, reject) {
        FB.api('/me/accounts', {
          access_token: token
        }, function (response) {
          if (response.error) {
            reject(response.error);
          }
          resolve(response.data);
        });
      });
    }
  }
})();
